var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { PreventionSectionType } from '../enum/prevention-section-type.js';
export class PreventionCourseModuleSectionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    index;
    title;
    description;
    sectionName;
    deviceText;
    preventionSectionType;
    videoModalTitle;
    videoModalText;
    videoId;
    loopVideoId;
    duration;
    readingDuration;
    repititionCount;
    repititionDuration;
    pauseDuration;
    preventionCourseModuleId;
    preventionCourseModule;
    thumbnailImage;
    trackings;
    preventionChapterMarkers;
    preventionChapterQuizQuestions;
    preventionEvaluationQuestions;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleSectionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseModuleSectionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseModuleSectionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", Number)
], PreventionCourseModuleSectionFullSizeDto.prototype, "index", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleSectionFullSizeDto.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "description", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleSectionFullSizeDto.prototype, "sectionName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "deviceText", void 0);
__decorate([
    IsEnum(PreventionSectionType),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionSectionType", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "videoModalTitle", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "videoModalText", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "videoId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "loopVideoId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionCourseModuleSectionFullSizeDto.prototype, "duration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionCourseModuleSectionFullSizeDto.prototype, "readingDuration", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "repititionCount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "repititionDuration", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "pauseDuration", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionCourseModuleId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionCourseModule", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PreventionCourseModuleSectionFullSizeDto.prototype, "thumbnailImage", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], PreventionCourseModuleSectionFullSizeDto.prototype, "trackings", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionChapterMarkers", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionChapterQuizQuestions", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseModuleSectionFullSizeDto.prototype, "preventionEvaluationQuestions", void 0);
//# sourceMappingURL=prevention-course-module-section.full-size.dto.js.map